import { useEffect } from 'react';
import s from './ResetModal.module.scss';

const ResetModal = ({ isOpen, onConfirm, onCancel }) => {
    useEffect(() => {
        if (!isOpen) return;

        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onCancel();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
    }, [isOpen, onCancel]);

    if (!isOpen) return null;

    return (
        <div className={s.Overlay} onClick={onCancel}>
            <div className={s.Modal} onClick={(e) => e.stopPropagation()}>
                <h3 className={s.Title}>Reset Configuration</h3>
                <p className={s.Message}>
                    This will clear all settings. Cannot be undone.
                </p>
                <div className={s.Actions}>
                    <button className={s.CancelButton} onClick={onCancel}>
                        Cancel
                    </button>
                    <button className={s.ResetButton} onClick={onConfirm}>
                        Reset
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ResetModal;
